<div class="container">
	<div class="card">
		<h1>
			{{ 'ssoLandingPage.cardTitle' | translate }}
		</h1>

		<p>{{ 'ssoLandingPage.chooseProviderText' | translate }}</p>

		<div class="button-container">
			@for (ssoProvider of availableSsoProviders; track ssoProvider) {
				<sso-landing-page-button
					class="button"
					[iconSrc]="ssoProvidersData[ssoProvider].iconSrc"
					[ssoProvider]="ssoProvider"
					(ssoProviderSelect)="onSsoProviderSelect($event)"
				/>
			}
		</div>
	</div>
</div>
